import React, { useEffect, useState } from "react";
import "./RecentReview.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { fetchReviewAndRatings } from "../../../ApiServices/ApiServices";
import { handleError } from "../../../Utils";

const RecentReview = ({ id, setRating }) => {
  const [review, setReview] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const fetchReviews = async (limit) => {
    try {
      if(!id) return ;
      const review = await fetchReviewAndRatings(id, limit);
      setRating(review?.data?.ratings);
      setReview(review?.data?.review);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    const limit = showAll ? null : 5; // If `showAll` is true, fetch all reviews; otherwise fetch 5
    fetchReviews(limit);
  }, [id, showAll]); // Re-fetch reviews when `id` or `showAll` changes

  const toggleShowAll = () => {
    setShowAll((prev) => !prev); // Toggle the `showAll` state
  };

  return (
    <div className="recent-review">
      <div className="recent-review-top">
        <div>Reviews & Testimonials</div>
      </div>

      {review?.map((item, index) => {
        return (
          <div key={index}>
            <div className="content-seprator"></div>
            <div className="recent-review-middle">{item?.desc}</div>
            <div className="recent-review-bottom flex">
              <div className="candidate-profile flex">
                <div className="candidate-profile-top flex">
                  {item?.userName?.charAt(0)}
                </div>
                <div>{item?.userName}</div>
              </div>
              <div className="comment-date">{item?.date}</div>
            </div>
          </div>
        );
      })}
      <div className="seprator flex">
        <div className="left-seprator"></div>
        <div className="show-all-review flex" onClick={toggleShowAll}>
        {showAll ? "Show Less" : "Show More"}
          <KeyboardArrowDownIcon />
        </div>
        <div className="left-seprator"></div>
      </div>
    </div>
  );
};

export default RecentReview;
